import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedFacade, noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'piqet-angular-custom-copy',
  templateUrl: './custom-copy.component.html',
  styleUrls: ['./custom-copy.component.scss'],
})
export class CustomCopyComponent {
  @Output() copyCustom = new EventEmitter<any>();
  copyCustomMaterialForm!: FormGroup;
  submitted = false;
  paramData: any;
  copyModalHeaderName: any;
  inputFieldDesc: any;
  validationText: any;
  isStorage: any;
  organizationName: any;
  errorMessage: any;
  isHideDropDown!: boolean;
  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    public sharedFacade: SharedFacade
  ) {
    this.copyModalHeaderName = this.modal?.modalService?.config?.initialState?.['copyHeaderName'];
    this.organizationName = this.modal?.modalService?.config?.initialState?.['organizationName'];
    this.isHideDropDown =
      this.copyModalHeaderName == 'adminCustomTrucks' ||
      this.copyModalHeaderName == 'adminCustomReuse' ||
      this.copyModalHeaderName == 'adminCustomStorage' ||
      this.copyModalHeaderName == 'adminCustomFilling' ||
      this.copyModalHeaderName == 'adminWasteScenarios' ||
      this.copyModalHeaderName == 'adminCustomTransport'
        ? true
        : false;
  }

  ngOnInit() {
    this.paramData = this.modal?.modalService?.config?.initialState?.['paramData'];
    this.copyCustomMaterialForm = this.formBuilder.group({
      materialName: ['', [Validators.required, Validators.maxLength(50), noWhitespaceValidator]],
      organizationName: [this.organizationName || null],
    });
    this.copyCustomMaterialForm.get('materialName')?.setValue(this.paramData + '_Copy');
    switch (this.copyModalHeaderName) {
      case 'customMaterials':
      case 'adminCustomMaterials':
        this.copyModalHeaderName = 'Copy custom material';
        this.inputFieldDesc = 'Material name';
        break;
      case 'customConversion':
      case 'adminCustomConversion':
        this.copyModalHeaderName = 'Copy conversion';
        this.inputFieldDesc = 'Conversion process name';
        this.errorMessage = 'Conversion process name';
        break;
      case 'customReuse':
      case 'adminCustomReuse':
        this.copyModalHeaderName = 'Copy reuse';
        this.inputFieldDesc = 'Reuse process name';
        break;
      case 'customStorage':
      case 'adminCustomStorage':
        this.isStorage = true;
        this.copyModalHeaderName = 'Copy custom storage';
        this.inputFieldDesc = 'Storage process name';
        break;
      case 'customTrucks':
      case 'adminCustomTrucks':
        this.copyModalHeaderName = 'Copy trucks';
        this.inputFieldDesc = 'Truck name';
        break;
      case 'customFilling':
      case 'adminCustomFilling':
        this.copyModalHeaderName = 'Copy filling';
        this.inputFieldDesc = 'Filling process name';
        break;
      case 'wasteScenarios':
      case 'adminWasteScenarios':
        this.copyModalHeaderName = 'Copy custom waste scenario';
        this.inputFieldDesc = 'Waste scenario name';
        break;
      case 'customTransport':
      case 'adminCustomTransport':
        this.copyModalHeaderName = 'Copy transport scenario';
        this.inputFieldDesc = 'Transport scenario name';
        this.errorMessage = 'Transport scenario name';
        break;
      default:
        break;
    }
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    if (this.copyCustomMaterialForm.valid) {
      const data = {
        name: this.copyCustomMaterialForm.controls['materialName'].value,
      };
      this.copyCustom.emit(data);
      this.modal.close();
    }
  }
}
